import Link from "next/link";
import style from "../../main_page/EntryBlock/EntryBlock.module.scss";
import MainBlob from "../../animate/MainBlob";

function EntryBlock({ dictionary }) {
	const title = dictionary["page_affiliate_header"] || "Earn money with BgRem";
	const description = dictionary["page_affiliate_descriptor"] || "Introduce your audience to BgRem, the popular Generative AI tool for creators & businesses, to earn 30% recurring commissions.";

	return (
		<section className={`${style.container} ${style.affiliate}`}>
			<div className={style.text}>
				<h1 className={style.title}>{title}</h1>
				<p className={style.subtitle}>{description}</p>
			</div>
			<div className={style.linkWrapper}>
				<a href="https://bgrem.firstpromoter.com/" target="_blank" rel="noreferrer" className={style.link}>
					{dictionary["page_affiliate_but"] || "Apply now"}
				</a>

				<div className={style.offer}>
					<p className={style.offerText} dangerouslySetInnerHTML={{ __html: dictionary["page_affiliate_already"] || "Already an affiliate? Log in as Affiliate " }} />
				</div>
			</div>

			<MainBlob />
		</section>
	);
}

export default EntryBlock;
